import ElibroIndex from '../Views/ElibroIndex'

const ElibroRoute = [{
    path: '/e-libro',
    name: 'e-libro',
    component: ElibroIndex,
}]

export default ElibroRoute
